
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-group-II-mains-test-series",
      function () {
        return require("private-next-pages/tnpsc-group-II-mains-test-series/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-group-II-mains-test-series"])
      });
    }
  